import { useQuery } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import SupplierProductService from "src/modules/3rd-party-management/apis/common/SupplierProductService";
import { Row, Col } from "reactstrap";
import Header from "./components/Header";
import Commodities from "./components/Commodities";

const DDSStatementDetailPage = ({
    t,
    productId
}) => {
    const {
        isFetching: fetchingInprocess,
        data: product
    } = useQuery({
        queryKey: [
            '3rd-party-management-fetch-supplier-product-detail',
            productId
        ],
        queryFn: async () => {
            const service = SupplierProductService.getInstance();

            return await service.show(productId, {});
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t('An error occurred while fetching product details.'), {
                type: 'error'
            });
        }
    });

    return (
        <div className="product-statement-detail-page">
            <Row>
                <Col sm='12'>
                    <Header 
                        isLoading={fetchingInprocess}
                        traceData={product?.traceStatement}
                    />
                </Col>

                <Col sm='12'>
                    <Commodities 
                        isLoading={fetchingInprocess}
                        traceData={product?.traceStatement}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default withNamespaces()(
    DDSStatementDetailPage
);